import "./App.css";
import { Routes, Route } from "react-router-dom";

import Contact from "./contact";
import About from "./about";
import Home from "./home";
import Work from "./work";
import Chat from "./chat";
import Navbr from "./navbar";

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#020617] via-[#020617] to-[#020617]">
      <Navbr />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/work" element={<Work />} />
          <Route path="/chat" element={<Chat />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
